//
//
//
//
//
//
export default {
  name: "App",
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;

    window.onresize = function () {
      _this.$store.commit("windowResize", {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }; // WebSocket 连接


    this.connectWebSocket(); // 初始化设备列表

    if (!localStorage.getItem("devicelist")) {
      localStorage.setItem("devicelist", '["产品图","产品型号","设备ID","状态","SN","操作"]');
    }
  },
  watch: {
    $route: function $route(_ref) {
      var path = _ref.path;
      sessionStorage.setItem("currPath", path);
    }
  },
  created: function created() {
    var loading = document.getElementById("loadigArea");

    if (loading) {
      loading.remove();
    }
  },
  methods: {
    connectWebSocket: function connectWebSocket() {
      // 替换为你的 WebSocket 服务器 URL
      var socket = new WebSocket("ws://your-websocket-server-url");

      socket.onopen = function () {
        console.log("WebSocket 连接已建立。");
      };

      socket.onmessage = function (event) {
        console.log("收到消息:", event.data); // 打印收到的消息

        _this.$store.commit("setWebsocketData", event.data);
      };

      socket.onerror = function (event) {
        console.error("WebSocket 发生错误:", event);
      };

      socket.onclose = function () {
        console.log("WebSocket 连接已关闭。");
      };
    }
  }
};